import React, { useState } from 'react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { safeHtml, stripHtml } from '../../lib/richText';

const pick = (lang, ar, en) => (lang === 'en' && en ? en : ar);

export const SimTabs = ({ sim }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const steps = (pick(lang, sim.instructionsAr, sim.instructionsEn) || '').split('\n').map(x => x.trim()).filter(Boolean);
  const tabs = [
    { key: 'instructions', label: L('تعليمات المحاكاة', 'Instructions'), steps },
    { key: 'explain', label: L('الشرح', 'Explanation'), html: pick(lang, sim.explainAr, sim.explainEn) },
    { key: 'diagram', label: L('مخطط الدائرة', 'Circuit diagram'), html: pick(lang, sim.diagramAr, sim.diagramEn) },
    { key: 'extra', label: L('معلومات إضافية', 'More info'), html: pick(lang, sim.extraAr, sim.extraEn) },
  ].filter(t => t.steps ? t.steps.length : stripHtml(t.html || '').trim() || /<img/i.test(t.html || ''));
  const [active, setActive] = useState(null);
  if (!tabs.length) return null;
  const cur = tabs.find(t => t.key === active) || tabs[0];
  return (
    <section data-testid="sim-tabs" className="rounded-3xl bg-white border border-slate-200 p-3 sm:p-4 shadow-sm">
      <div role="tablist" className="flex gap-2 overflow-x-auto pb-3 border-b border-slate-100">
        {tabs.map(t => (
          <button key={t.key} role="tab" type="button" data-testid={`sim-tab-${t.key}`} aria-selected={cur.key === t.key} onClick={() => setActive(t.key)}
            className={`shrink-0 h-11 px-5 rounded-xl text-sm font-bold transition-colors ${cur.key === t.key ? 'bg-blue-50 text-blue-700 border-b-2 border-blue-600' : 'text-slate-600 hover:bg-slate-50'}`}>{t.label}</button>
        ))}
      </div>
      {cur.steps ? (
        <ol data-testid="sim-tab-content" className="space-y-2.5 pt-4 px-1">
          {cur.steps.map((s, i) => (
            <li key={i} data-testid={`sim-instruction-${i}`} className="flex items-start gap-2.5 text-sm sm:text-base text-slate-700 leading-relaxed">
              <span className="w-6 h-6 shrink-0 rounded-full bg-blue-600 text-white text-xs font-black flex items-center justify-center">{i + 1}</span>{s}
            </li>
          ))}
        </ol>
      ) : (
        <div data-testid="sim-tab-content" className="rich-content article-body text-slate-700 text-sm sm:text-base leading-relaxed pt-4 px-1" dangerouslySetInnerHTML={{ __html: safeHtml(cur.html) }} />
      )}
    </section>
  );
};
